module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "attention-car-2.2f842b34.png" + "?" + Date.now();